import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/past-conversations.vue
var o = {
	name: "DtIconPastConversations",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--past-conversations"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Past Conversations",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M1.646 7.646a.5.5 0 1 1 .708.708L1.707 9H9a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 9 3H4.5a.5.5 0 0 0-.5.5V6a.5.5 0 1 1-1 0V3.5A1.5 1.5 0 0 1 4.5 2H9a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 9 10H1.707l.647.646a.5.5 0 1 1-.708.707l-1.5-1.5a.5.5 0 0 1 0-.707l1.5-1.5ZM7.5 7.25a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h2.5Zm1-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Zm0-1.75a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=past-conversations.js.map